import { HStack, Box } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import RewardsButton from 'ui/rewards/RewardsButton';
import UserProfileDesktop from 'ui/snippets/user/profile/UserProfileDesktop';
import UserWalletDesktop from 'ui/snippets/user/wallet/UserWalletDesktop';

type Props = {
  renderSearchBar?: () => React.ReactNode;
};

const HeaderDesktop = ({ renderSearchBar }: Props) => {

  // Desktop search is rendered next to page title (via `PageTitle`) for non-home pages.
  // Keep `renderSearchBar` only for special pages (e.g. Search results) if they still choose to use it.
  const searchBar = renderSearchBar ? renderSearchBar() : null;
  const hasSearchBar = Boolean(searchBar);

  return (
    <HStack
      as="header"
      display={{ base: 'none', lg: 'flex' }}
      width="100%"
      alignItems="center"
      justifyContent={ hasSearchBar ? 'center' : 'flex-end' }
      gap={ 6 }
    >
      { hasSearchBar && (
        <Box width="100%">
          { searchBar }
        </Box>
      ) }
      { config.UI.navigation.layout === 'vertical' && (
        <Box display="flex" gap={ 2 } flexShrink={ 0 }>
          { config.features.rewards.isEnabled && <RewardsButton/> }
          {
            (config.features.account.isEnabled && <UserProfileDesktop/>) ||
            (config.features.blockchainInteraction.isEnabled && <UserWalletDesktop/>)
          }
        </Box>
      ) }
    </HStack>
  );
};

export default React.memo(HeaderDesktop);
